import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { LabService } from 'src/app/services/lab.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { ToastrService } from 'ngx-toastr';

import { WindowreffService } from 'src/app/services/windowreff.service';
import { AmazingTimePickerService } from '../../shared/time-picker-compat/amazing-time-picker.service';
import { AuthService } from 'src/app/services/auth.service';
//import {CalendarModule} from 'primeng/calendar';
import {Maps} from '../../../assets/mapModel'
;
//directives:[Calendar]
declare var google: any;
@Component({
  selector: 'app-lab-detail',
  templateUrl: './lab-detail.component.html',
  styleUrls: ['./lab-detail.component.css'],


})
export class LabDetailComponent implements OnInit {
  labDetail:any={}
  isLoggedIn=localStorage.getItem('token') ? true : false 
  labTestData=<LabTest[]>[]
  labCartData:any=[]
  sendLabData:any=[]
  labShow =[]
  addressFields=<LabUserAddress>{}
  totalAmount:number=0
  availability:any=[]
  realAddress:boolean=false
  labReviews:any=[]
  isDisable:boolean=true
 
  imageUrlArray:any=[]
  minDateValue:Date=new Date()
  valueDate:Date=null
  valueTime:any= null
  timeobj:any={}
  slideConfigCustomers = {
    infinite: true,
    speed: 300,
    arrows: false,
    autoplay:true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };
  finalObj:any={
    customerDetail:{
      name:'',
      phone:'',
      email:''
    },
    cardDetail:{
      cardNumber:'',
      cardExpDate:'',
      cardCvv:'',

    },
    addressDetail:{
      address:'',
      landmark:'',
      city:'',
      state:'',
      pincode:''
    }
  }
  
  @ViewChild("placesRef") placesRef : GooglePlaceDirective
  options={
    types: [],
    componentRestrictions: { country: 'in' }
    }

     // map keys
  map: any = {};
  marker: any = {};
  mapKeys = Maps;
  constructor(public labSvc:LabService,private toaster: ToastrService, 
    public activatedRoute:ActivatedRoute,
    public datepipe: DatePipe,
    private winRef: WindowreffService,
    private ngZone:NgZone,
    private atp: AmazingTimePickerService,
    private auth:AuthService,
    private router:Router) { }

  ngOnInit() {
   // console.log(this.minDateValue)
    //document.getElementById('lab_order_details_trigger').click()
    let date = new Date();
    let latest_date =this.datepipe.transform(date, 'dd-MM-yyyy');
   // console.log(latest_date)
    if(this.activatedRoute.snapshot.params.id)
      this.getLabDetail(this.activatedRoute.snapshot.params.id,latest_date)
      this.getCurrentLocation()
  }
  payWithRazor(){ 
    if(this.totalAmount==0){
      document.getElementById('lab_order_details_trigger').click()
      this.bookLabTest()
    }
    else{
    document.getElementById('lab_order_details_trigger').click()
    let options:any = {
      "key": "rzp_live_YmyxdRilAgKlpK",// test key :rzp_test_dvfpRNEUlLTuCq
        "amount": this.totalAmount*5,
        "name": "Daktarz",
        "description": "Lab Booking",
       // "image": "../assets/images/logo.png",
        "modal": {
          "escape": false
        }, 
        "prefill": {
          "name": this.finalObj.customerDetail.name,
          "contact": this.finalObj.customerDetail.phone,
          "email": this.finalObj.customerDetail.email,
          "method": 'card',
          'card[number]': this.finalObj.cardDetail.cardNumber,
          'card[expiry]': this.finalObj.cardDetail.cardExpDate,
          'card[cvv]': this.finalObj.cardDetail.cardCvv
        },
        "notes": {
          "address": this.finalObj.addressDetail.address + ', ' + this.finalObj.addressDetail.landmark + ', ' + this.finalObj.addressDetail.city + ', ' + this.finalObj.addressDetail.state + '-' + this.finalObj.addressDetail.pincode
        },
        "theme": {
          "color": "#26abe3"
        }
      };
      options.handler = ((response) => {
        console.log(response)
          if(response.razorpay_payment_id){
            this.addressFields.transactionId = response.razorpay_payment_id
            this.bookLabTest()
          }
        // this.paymentService.payWithRazor({cart: this.finalObj, payment: options});
      });
      options.modal.ondismiss = (() => {
        //  this.loginService.SetLoader = false;
      });
      let rzp = new this.winRef.nativeWindow.Razorpay(options);
      rzp.open();
    }
  }

  getPriceAfterDiscount(price,discount){
 
    return Number(price-(price*discount/100)).toFixed(2)
  }
  getLabDetail(labId:string,date){
    this.labSvc.getLabDetail(labId,date).subscribe(res=>{
   console.log(res)
      this.labDetail = res["data"][0]
      this.labReviews = this.labDetail.review.reverse().slice(0,5)

      this.availabilityTiming(this.labDetail.timings)
     // console.log( this.labDetail.labTests)
      this.labDetail.labTests.map(test=>{
       test.quantity = 0
       this.labTestData.push({labTestId:test._id,quantity:0,price:test.price-(test.price*this.labDetail.discount/100)})
       
      })
      this.totalAmount = 0
      this.labShow = this.labDetail.labTests
      
    },error=>{

    })

  }
  updateTest(number,labTestId,labTest){
   
   
    let lab = this.labShow.find(singleTest=>{ 
     
     return singleTest._id== labTestId
    })

    let singleSend = this.labTestData.find(singleTest=>{ 
     
      return singleTest.labTestId== labTestId
     })

    if(number==-1 && lab.quantity==0){
    }
      else{
    lab.quantity = lab.quantity + number
    
    singleSend.quantity = singleSend.quantity + number
    this.totalAmount = this.totalAmount + number*(lab.price-(lab.price*this.labDetail.discount/100))
    this.totalAmount = Number(this.totalAmount.toFixed(2))
   


    }
    this.sendLabData = this.labTestData.filter(singleTest=>singleTest.quantity>0)
   
   // console.log(this.sendLabData)
  }

  open() {
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe(time => {
      let time1 = this.tConvert(time)
      this.timeobj.openTimeString = time1.split(' ')[0]
      this.timeobj.openTimeMeridian = time1.split(' ')[1]
      let calculate  = time1.split(' ')[0].split(':')
      if(time1.split(' ')[1]=='am'){
        if(parseInt(calculate[0])==12){
          this.valueTime =  0 + ":"+ calculate[1]
        }
        else{
        this.valueTime = calculate[0] + ':' + calculate[1]
        }
      }
      else{
        if(parseInt(calculate[0])==12){
          this.valueTime = 12 + ':' + calculate[1]
        }
        else{
          this.valueTime = (parseInt(calculate[0])+12) + ':' + calculate[1]

        }
       
       
      }
      this.changed()

    })
  }
  bookLabTest(){
   
  this.addressFields.lat = this.addressFields.lat ? this.addressFields.lat : Number(localStorage.getItem('lat'))
  this.addressFields.lng = this.addressFields.lng ? this.addressFields.lng : Number(localStorage.getItem('lng'))

    this.labSvc.bookLabTest(this.sendLabData,this.addressFields).subscribe(res=>{
      localStorage.removeItem('labBookingData')
    
    // document.getElementById('order_confirm').click()
     this.ngZone.run(()=>{
this.toaster.success('Booking Successful','Success',{
  timeOut: 2000
})

localStorage.setItem('tab','labs')
this.navigateTo('/user-orders');
})
     
    },error=>{
      this.ngZone.run(()=>{
      this.toaster.error(error.error.message, 'Error',{
        timeOut: 2000
      });
    })

    })
  }
  navigateTo(url){
    this.router.navigate([url])
  }
  gotoCart(){
    // console.log(this.valueDate.getTime())
    // return false;

    let year = this.valueDate.getFullYear()
    let month = this.valueDate.getMonth()+ 1
    let day = this.valueDate.getDate()
   let date = year + '/' + month + '/' + day
  //  let hours = this.valueTime.getHours()
  //  let min = this.valueTime.getMinutes()
  //  let sec = this.valueTime.getSeconds()
   //let time = hours + ':' + min + ':' + sec
   let timeDate = date + ' ' + this.valueTime

   let timestamp  = Math.round(new Date(timeDate).getTime())
   console.log(timestamp)

    this.addressFields.dateTime = timestamp

    document.getElementById('address_lab').click()

    document.getElementById('lab_order_details_trigger').click()
  
  
  
  }
  changed(){
    setTimeout( () => {
    this.getTimingStatus()

  }, 1000 );
  }
  getTimingStatus(){
  
    if(this.valueTime==null || this.valueDate==null ){
      this.isDisable=true
      return false
    }
    let year = this.valueDate.getFullYear()
    let month = this.valueDate.getMonth()+ 1
    let day = this.valueDate.getDate()
   let date = year + '/' + month + '/' + day
//console.log(this.valueTime)

  // let hours = this.valueTime.getHours()
  //  let min = this.valueTime.getMinutes()
  //  let sec = this.valueTime.getSeconds()
  //  let time = hours + ':' + min + ':' + sec
   let timeDate = date + ' ' + this.valueTime
console.log(this.valueTime)
   let timestamp  = Math.round(new Date(timeDate).getTime())
   let current_time = new Date().getTime()
   console.log(timestamp)
   console.log(current_time)
  if(current_time>timestamp)
    {
      this.isDisable=true
      this.toaster.error("Booking Time already passed...", 'Error',{
        timeOut: 2000
      });
      return false
    }
    this.addressFields.dateTime = timestamp
    this.labSvc.getTimingStatus(this.activatedRoute.snapshot.params.id,this.addressFields).subscribe(res=>{
      if(res["data"]["timingStatus"]){

        if(!this.addressFields.address || !this.addressFields.city || !this.addressFields.lat || !this.addressFields.lng){
          this.isDisable=true
        }
        else{
        this.isDisable=false
        }
      // this.checkDistanceStatus()
    
      }
      else{
        this.isDisable=true
        this.toaster.error("Booking Time not available..Please select another time", 'Error',{
          timeOut: 2000
        });
      }
    },error=>{
      this.isDisable=true
      this.toaster.error(error.error.message, 'Error',{
        timeOut: 2000
      });
    })

  
   
    
  }
  clearTest(){
    this.labTestData.map(lab=>{
      lab.quantity=0
    })
    this.labShow.map(lab=>{ 
     
      lab.quantity=0
     })
    this.totalAmount = 0
  }
  availabilityTiming(timing){
    let lengthTimings  =timing.length
  
        for(let i=0;i<lengthTimings;i++){
        //  console.log('yes')
        if(!timing[i].startTime || !timing[i].endTime){

        }
        else if(this.tConvert(timing[i].startTime)==this.tConvert(timing[i].endTime)){
          this.availability.push({timing:timing[i].showDay!=null ? timing[i].showDay+' | ' + this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime) :  this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime),error:false})
        }
        else{
       
        this.availability.push({timing:timing[i].showDay!=null ? timing[i].showDay+' | ' + this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime) :  this.tConvert(timing[i].startTime)+' - '+this.tConvert(timing[i].endTime),error:false})
        }
        }
          
        
  }
  removeFromCart(labTest){
    let index = this.labCartData.findIndex(test=>test._id==labTest._id)
    let quantity = this.labCartData[index].quantity
  //  console.log(quantity)
    this.labCartData.splice(index,1)
   
    this.updateTest(-quantity,labTest._id,labTest)
    let showindex = this.labShow.findIndex(test=>test._id==labTest._id)
    this.labShow[showindex].quantity = 0
    if(this.labCartData.length==0)
      document.getElementById('lab_order_details_trigger').click()
  }
  removeLabData(){
    localStorage.removeItem('labBookingData')
  }
  getCurrentLocation() {
    // if(!this.isLoggedIn){
    //   this.bookObject['name'] = ''
    //   this.bookObject['phoneNo'] = ''
    // }
    // this.bookObject['name'] = '';
  
    this.auth.getLocation().then(location => {
      if(!location.nolocation){
        this.addressFields.lat = Number(localStorage.getItem('lat')) 
             this.addressFields.lng = Number(localStorage.getItem('lng')) 
       
         
      }
      else{
      this.addressFields.lng = 76.7794 
             this.addressFields.lat = 30.7333
      }
      this.initializeMap()
   
      

     
   
    
    })

    //this.bookObject['address'] = localStorage.getItem('currentaddress');
  }
  initializeMap() {
    var latlng = new google.maps.LatLng(this.addressFields.lat, this.addressFields.lng);
    var myOptions = {
      zoom: this.mapKeys.zoomModal,
      center: latlng,
     // styles: this.mapKeys.style,
      streetViewControl: false,
      disableDefaultUI: false,
      mapTypeControl: false,
      gestureHandling: "greedy"
    };
    this.map = new google.maps.Map(document.getElementById("mapLocation"), myOptions);
    this.map.setCenter(latlng);
    this.getLocation();
    //const self = this;
    this.map.addListener('center_changed', () => {
      this.getLocation();
    });

  }
  getLocation() {
    //const self = this;
    this.addressFields.lat = this.addressFields.lat
    this.addressFields.lng = this.addressFields.lng
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({
      'latLng': this.map.getCenter()
    }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        if (!!results && results.length) {
          console.log('results[0].formatted_address', results[0].formatted_address)
          this.addressFields.address = results[0].formatted_address;
          localStorage.setItem('currentaddress',results[0].formatted_address)

          results[0].address_components.map((addr:any)=>{
 
     
            if(addr.types[0]=='locality' && addr.types[1]=='political'){
              localStorage.setItem('currentcity',addr.long_name) 
              
              
            }
           
        
        })
          
        }
      }
    });
  }
  loginFirst(){
    this.valueDate = null
    this.valueTime = null
    this.addressFields.dateTime = null
    this.isLoggedIn = localStorage.getItem('token') ? true : false
    this.labCartData = this.labShow.filter(singleTest=>singleTest.quantity>0)
    if( this.isLoggedIn){
      //this.bookLabTest()
      this.addressFields.address=localStorage.getItem('currentaddress') ? localStorage.getItem('currentaddress') : JSON.parse(localStorage.getItem('logindata'))['address']
      this.addressFields.city=JSON.parse(localStorage.getItem('logindata'))['city'] ? JSON.parse(localStorage.getItem('logindata'))['city'].toLowerCase() : localStorage.getItem('currentcity').toLowerCase()
      this.addressFields.lat=Number(localStorage.getItem('lat'))
      this.addressFields.lng=Number(localStorage.getItem('lng'))
     
     // document.getElementById('lab_order_details_trigger').click()
      document.getElementById('address_lab').click()
    }
   
    else{
      localStorage.setItem('labBookingData',JSON.stringify(this.sendLabData))
      document.getElementById('logintoggle_user').click()
    }
   
    
   
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView();
}
handleAddressChange(event){
  var latlng = new google.maps.LatLng(event.geometry.location.lat(), event.geometry.location.lng());
  this.map.setCenter(latlng);
  this.realAddress=true
  this.addressFields.address = event.formatted_address
  this.addressFields.lat = event.geometry.location.lat()
  this.addressFields.lng = event.geometry.location.lng()
  let flag=0
   event.address_components.map((addr:any)=>{
 
     
      if(addr.types[0]=='locality' && addr.types[1]=='political'){
        this.addressFields.city = addr.long_name.toLowerCase()
        flag=1
        
      }
     
  
  })
  if(flag==0)  
    this.addressFields.city = event.formatted_address.split(',')[0].toLowerCase()

    this.checkDistanceStatus()

}
checkDistanceStatus(){

  this.labSvc.labDistance(this.addressFields,this.activatedRoute.snapshot.params.id).subscribe(res=>{
    if((parseInt(res["data"]["distance"])/1000)<=20){
      if(this.addressFields.dateTime){
        this.isDisable = false
      }
    
     // this.getTimingStatus()
    }
    else{
      this.isDisable = true
      this.toaster.error('Lab Too Far from your location...', 'Error',{
        timeOut: 2000
      });
    }
    },error=>{
      this.isDisable = true
      this.toaster.error(error.error.message, 'Error',{
        timeOut: 2000
      });
    })
}
checkAddress(){
 // console.log('sdfsd')
  this.realAddress=false
}
tConvert (time) {
  // Check correct time format and split into components
//time = '12:28'
  let time1 = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
let time2:any

  if (time1.length>1) { // If time format correct
     time2 = time1.slice (1);  // Remove full string match value
    time2[5] = +time2[0] < 12 ? ' am' : ' pm'; // Set AM/PM
    time2[0] = +time2[0] % 12 || 12; // Adjust hours
  }
  else{

  }
  //console.log(time2)
 return  time2.join ('') // return adjusted time or original string
}
counter(i: number) {
  return new Array(i);
}
showImages(){
  this.imageUrlArray=this.labDetail.images
  //console.log(this.imageUrlArray)
  document.getElementById('orderImagesCLick').click()
}

showImagePopup(image){
  this.imageUrlArray=[]
  this.imageUrlArray.push(image)
  document.getElementById('orderImagesCLick').click()
}



}
export interface LabTest{
  labTestId:string,
  quantity :number,
  price:number
}
export interface LabUserAddress{
  address:string,
  city :string,
  lat:number,
  lng:number,
  dateTime:number,
  transactionId?:string
}
export interface PharmacyUserAddress{
  address:string,
  city :string,
  lat:Number,
  lng:Number,
 // dateTime:number
}
